export const TX_MIGRATE_AMOUNT_SET = 'TX_MIGRATE_AMOUNT_SET';
export const TX_MIGRATE_ADDRESS_SET = 'TX_MIGRATE_ADDRESS_SET';
export const TX_MIGRATE_MEMO_SET = 'TX_MIGRATE_MEMO_SET';
export const TX_MIGRATE_MODAL_SHOW = 'TX_MIGRATE_MODAL_SHOW';
export const TX_MIGRATE_BUTTON_STATUS = 'TX_MIGRATE_BUTTON_STATUS';
export const TX_MIGRATE_AMOUNT_ERROR = 'TX_MIGRATE_AMOUNT_ERROR';
export const TX_MIGRATE_MODAL_HIDE = 'TX_MIGRATE_MODAL_HIDE';
export const TX_MIGRATE_TOKENS_LIST_SET = 'TX_MIGRATE_TOKENS_LIST_SET';
